<template>
  <b-modal
    class="modal-view-objective-employee text-muted"
    id="modal-view-objective-employee"
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    size="s"
    :title="'Objective' + ' ' + items.nameObjective"
  >
    <div>
      <b-table
        ref="table"
        striped
        :fields="fields"
        :items="employees"
        @onchange="$refs.table.refresh()"
      >
        <template #cell(action)="{ item }">
          <div>
            <b-link class="text-white">
              <b-button variant="warning" @click="removeEmployeeObjective(item.id)">
                <b-icon icon="dash"></b-icon>
              </b-button>
            </b-link>
          </div>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    items: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fields: [
        { key: 'employeeNo', label: 'No', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'name', label: 'Employee', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'action', label: 'Action', thClass: 'text-center', tdClass: 'text-center' }
      ],
      employees: [],
      nameTitle: ''
    }
  },
  methods: {
    removeEmployeeObjective(id) {
      this.$emit('remove', id)
      this.$bvModal.hide('modal-view-objective-employee')
    }
  },
  watch: {
    items: {
      handler() {
        this.employees = []
        this.employees = this.items.idEmployee
        if (this.items.idEmployee.length === 0) {
          this.employees = []
        }
      },
      deep: true
    }
  }
}
</script>
